@file:OptIn(kotlin.js.ExperimentalWasmJsInterop::class)

private fun webGlAvailable(): Boolean = js(
    """
    (() => {
        try {
            const canvas = document.createElement('canvas');
            return !!(canvas.getContext('webgl2') || canvas.getContext('webgl'));
        } catch (_) {
            return false;
        }
    })()
    """
)

actual fun isBrowserWebGlAvailable(): Boolean = webGlAvailable()

actual fun showBrowserStartupError() {
    js(
        """
        (() => {
            document.body.innerHTML = '';
            const panel = document.createElement('main');
            panel.style.cssText = 'box-sizing:border-box;min-height:100vh;display:grid;place-content:center;padding:32px;font-family:system-ui,sans-serif;color:#1f2937;text-align:center;background:#f8fafc';
            const userAgent = navigator.userAgent;
            const browser = userAgent.includes('Edg/') ? 'Edge' : userAgent.includes('Chrome/') ? 'Chrome' : userAgent.includes('Firefox/') ? 'Firefox' : userAgent.includes('Safari/') ? 'Safari' : 'your browser';
            const instruction = browser === 'Safari'
                ? 'In Safari, check Settings → Advanced and ensure WebGL is enabled under Experimental Features.'
                : browser === 'Firefox'
                    ? 'In Firefox, open Settings → General → Performance, enable recommended performance settings and hardware acceleration, then restart Firefox.'
                    : 'In ' + browser + ', enable “Use graphics acceleration when available” in the browser system settings, then restart the browser.';
            panel.innerHTML = '<h1>Graphics acceleration is unavailable</h1><p>iConnect.School needs WebGL to start, but ' + browser + ' is not providing it.</p><p>' + instruction + '</p><p>If you are using remote desktop or screen sharing, reconnect locally and try again.</p><button onclick="location.reload()" style="padding:10px 18px;cursor:pointer">Reload iConnect.School</button>';
            document.body.appendChild(panel);
        })()
        """
    )
}
